export const SHOP_GEOGRAPHICAL_AREA_PAGE_SLUG = "shop-geographical-area";

export const SHOP_FALLBACK_GEOGRAPHICAL_AREA = "empty";
